import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import AdminScorecardActions from 'actions/scorecards/AdminScorecardActions';
import EditScorecardActions from 'actions/scorecards/EditScorecardActions';
import Scorecard from 'records/Scorecard';
import Question from 'records/Question';
import ToastStore from '@store/toast/ToastStore';
import {List, Record} from 'immutable';

@immutableStore
class EditScorecardStore {
  constructor() {
    this.state = Record({
      scorecard: null,
      initialScorecard: null,
      wasErrorFetching: false,
      isLoading: false,
      wasErrorSaving: false,
      isSaving: false,
    })();
    this.bindActions(EditScorecardActions);
    this.bindActions(AdminScorecardActions);
  }

  fetchScorecard() {
    this.setState({
      initialScorecard: null,
      scorecard: null,
      isLoading: true,
      wasErrorFetching: false,
    });
  }

  fetchScorecardSuccess(scorecard) {
    this.setState({isLoading: false, scorecard, initialScorecard: scorecard});
  }

  fetchScorecardError() {
    this.setState({isLoading: false, wasErrorFetching: true});
  }

  updateForm(scorecard) {
    this.setState({scorecard});
  }

  initializeForm() {
    const scorecard = new Scorecard({
      scoringScheme: 'one_to_five',
    }).set('questions', List([new Question()]));

    this.setState({
      wasErrorFetching: false,
      scorecard: scorecard,
      initialScorecard: scorecard,
      wasErrorSaving: false,
      isSaving: false,
    });
  }

  createScorecard() {
    this.setState({
      wasErrorSaving: false,
      isSaving: true,
    });
  }

  createScorecardError() {
    this.setState({
      wasErrorSaving: true,
      isSaving: false,
    });
    ToastStore.addToast({
      type: 'error',
      message: 'There was a problem saving the scorecard.',
    });
  }

  createScorecardSuccess(scorecard) {
    this.setState({
      scorecard,
      isSaving: false,
    });
    ToastStore.addToast({
      type: 'success',
      time: 2000,
      message: 'Scorecard created!',
    });
  }

  updateScorecard() {
    this.createScorecard();
  }

  updateScorecardError() {
    this.createScorecardError();
  }

  updateScorecardSuccess(scorecard) {
    this.setState({
      scorecard,
      isSaving: false,
    });
    ToastStore.addToast({
      type: 'success',
      time: 2000,
      message: 'Scorecard updated!',
    });
  }
}

export default alt.createStore(EditScorecardStore);
